import React from 'react';
import { SvgIcon, SvgIconProps } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';

export interface BenefitTileProps {
  icon: SvgIconProps;
  title: string;
  copy: string;
}

const blockName = 'benefit-tile';

export default function BenefitTile({ icon, title, copy }: BenefitTileProps) {
  const bem = bemBlock(blockName);

  return (
    <div className={bem()}>
      <SvgIcon {...icon} className={bem('icon')} />
      <div className={bem('title')}>{title}</div>
      <div className={bem('copy')}>{copy}</div>
    </div>
  );
}
